export default __webpack_public_path__ + "static/media/dongho-1.2a155c50.jpg";